import { toast } from "react-toastify";

/**
 * Robust utility function to copy text to clipboard with feedback and fallback support.
 */
export const handleCopy = (arg1, arg2, e) => {
  if (e && typeof e.stopPropagation === "function") {
    e.stopPropagation();
  }

  let textToCopy = "";
  let setCopiedState = null;

  if (typeof arg1 === "function") {
    setCopiedState = arg1;
    textToCopy = arg2;
  } else if (typeof arg2 === "function") {
    textToCopy = arg1;
    setCopiedState = arg2;
  } else {
    textToCopy = String(arg1 || arg2 || "");
  }

  if (!textToCopy) return;

  const onSuccess = () => {
    if (typeof setCopiedState === "function") {
      setCopiedState(textToCopy);
      setTimeout(() => setCopiedState(null), 1500);
    }
    toast.success("Copied to clipboard!");
  };

  const onError = (err) => {
    console.error("Copy failed:", err);
    toast.error("Failed to copy text");
  };

  if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(textToCopy).then(onSuccess, () => fallbackCopy(textToCopy, onSuccess, onError));
  } else {
    fallbackCopy(textToCopy, onSuccess, onError);
  }
};

const fallbackCopy = (textToCopy, onSuccess, onError) => {
  try {
    const textarea = document.createElement("textarea");
    textarea.value = textToCopy;
    textarea.style.position = "fixed";
    textarea.style.left = "-9999px";
    textarea.style.top = "-9999px";
    document.body.appendChild(textarea);
    textarea.select();
    textarea.setSelectionRange(0, 99999);
    const successful = document.execCommand("copy");
    document.body.removeChild(textarea);
    if (successful) {
      onSuccess();
    } else {
      onError();
    }
  } catch (err) {
    onError(err);
  }
};

export default handleCopy;
